//Types
import {
  CLOSE_SUBCATEGORY_TOAST,
  CLOSE_SUBCATEGORY_DIALOG,
  DELETE_SUBCATEGORY,
  GET_SUBCATEGORIES,
  INSERT_SUBCATEGORY,
  OPEN_SUBCATEGORY_TOAST,
  OPEN_SUBCATEGORY_DIALOG,
  TOGGLE_SUBCATEGORY_STATUS,
  UPDATE_SUBCATEGORY,
} from "./subCategory.type";

//Define InitialState
const initialState = {
  subCategories: [],
  dialog: false,
  dialogData: null,
  toast: false,
  toastData: null,
  actionFor: null,
};

const subCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    //Get SubCategories
    case GET_SUBCATEGORIES:
      return {
        ...state,
        subCategories: action.payload,
      };

    //Insert Team
    case INSERT_SUBCATEGORY:
      const data = [...state.subCategories];
      // Find the category object to add name to the subCategory data
      const subCategoryWithCategory = {
        ...action.payload,
      };
      data.unshift(subCategoryWithCategory);
      return {
        ...state,
        subCategories: data,
      };

    //Update Team
    case UPDATE_SUBCATEGORY:
      return {
        ...state,
        subCategories: state.subCategories.map((subCategory) =>
          subCategory._id === action.payload.id ? action.payload.data : subCategory
        ),
      };

    //Delete Team
    case DELETE_SUBCATEGORY:
      return {
        ...state,
        subCategories: state.subCategories.filter((subCategory) => subCategory._id !== action.payload),
      };

    //Toggle Status
    case TOGGLE_SUBCATEGORY_STATUS:
      return {
        ...state,
        subCategories: state.subCategories.map((subCategory) =>
          subCategory._id === action.payload.id 
            ? { ...subCategory, isActive: action.payload.isActive } 
            : subCategory
        ),
      };

    //Open Dialog
    case OPEN_SUBCATEGORY_DIALOG:
      return {
        ...state,
        dialog: true,
        dialogData: action.payload || null,
      };

    //Close Dialog
    case CLOSE_SUBCATEGORY_DIALOG:
      return {
        ...state,
        dialog: false,
        dialogData: null,
      };

    //Open Toast
    case OPEN_SUBCATEGORY_TOAST:
      return {
        ...state,
        toast: true,
        toastData: action.payload.data || null,
        actionFor: action.payload.for || null,
      };

    //Close Toast
    case CLOSE_SUBCATEGORY_TOAST:
      return {
        ...state,
        toast: false,
        toastData: null,
        actionFor: null,
      };
    default:
      return state;
  }
};

export default subCategoryReducer; 